import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { SentryService } from "./sentry.service";
import { useAuthStore } from "@/features/auth";

export function SentryRouteTracker() {
  const { pathname } = useLocation();
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    const moduleName = SentryService.extractModule(pathname);
    Sentry.setTag("route", pathname);
    Sentry.setTag("module", moduleName);
    Sentry.addBreadcrumb({
      category: "navigation",
      message: pathname,
      level: "info",
    });
  }, [pathname]);

  useEffect(() => {
    if (user) {
      const name = [user.firstName, user.lastName].filter(Boolean).join(" ") || undefined;
      SentryService.setUser({
        id: user.id,
        email: user.email,
        name,
        role: user.role,
        tenant_id: user.tenant_id,
      });
    } else {
      SentryService.clearUser();
    }
  }, [user]);

  return null;
}
